import "./table.scss";
import { Paragraph } from "../Paragraph";
import type { TableProps } from "./Table.interface";

/**
 * Primary UI component for user interaction
 */
export function Table(props: TableProps) {

	function checkIfDataIsComplete() {
		let dataComplete = true;
		props.rows.forEach(row => {
			if (row.length !== props.numberOfCols) {
				dataComplete = false;
			}
		});
		return dataComplete;
	}

	if (!checkIfDataIsComplete()) {
		return <></>;
	}

	return (<div className={["table", props.className].join(" ")}>
		<div className="table-header desktop">

			{
				props.firstRowAsHeader &&
				<>
					<div className="table-header-row">
						{props.rows[0].map((entry, i) => {
							return <div key={`thead-${i}`} className="table-header entry">
								<h3>
									{entry}
								</h3>
							</div>;
						})
						}
					</div>
					<hr className={"dark"} />
				</>
			}
		</div>
		<div className={"table-content desktop"}>
			{
				props.rows.map((row, index) => {
					const firstIndex = props.firstRowAsHeader ? 1 : 0;
					if (props.rows.indexOf(row) === 0 && props.firstRowAsHeader) {
						return <></>;
					}
					return (
						<>
							{
								index !== firstIndex &&
								<hr className={"light"} />
							}
							<div key={"table-entry-" + index} className={"table-content-row"}>
								{
									row.map((entry, i) => {
										return (
											<div key={`table-col-${index}-${i}`} className="table-content entry">
												<Paragraph text={entry} />
											</div>
										);
									})
								}
							</div>
						</>);
				})
			}
		</div>
		<div className={"table-content mobile"}>
			{
				props.rows.map((row, rowIndex) => {
						const firstIndex = props.firstRowAsHeader ? 1 : 0;
						if (props.rows.indexOf(row) === 0 && props.firstRowAsHeader) {
							return <></>;
						}
						return (
							<>
								{
									rowIndex !== firstIndex &&
									<hr className={"light"} />
								}
								<div key={"table-entry-" + rowIndex} className={"table-content-row"}>
									{
										row.map((entry, entryIndex) => {
												return (
													<div key={`table-entry-${rowIndex}-${entryIndex}`} className="table-content entry">
														<Paragraph
															text={props.firstRowAsHeader ? props.rows[0][entryIndex] + ": " + entry : entry} />
													</div>
												);
											},
										)
									}
								</div>
							</>
						);
					},
				)
			}
		</div>
	</div>);
}
